<div class="flex-space-between">
  @if (tabs?.length) {
    <app-tabs
      [tabs]="tabs">
    </app-tabs>
  }

  @if (authService.isBasicSupportUser) {
    <div class="action-header_container">
      @if (buttonList?.length) {
        <app-button-list
          [list]="buttonList">
        </app-button-list>
      }
    </div>
  }
</div>

<br>

  <app-data-grid
    [data]="gridData$ | async"
    [loading]="isLoading"
    [filterable]="true"
    [filter]="filter"
    (filterChange)="filterChange($event)"
    [sortable]="true"
    [sort]="sort"
    (sortChange)="sortChange($event)"
    [pageable]="true"
    [pageSize]="pageSize"
    [skip]="skip"
    (pageChange)="pageChange($event)"
    [height]="700">
    <app-data-grid-column
      field="name"
      title="{{ 'name' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="office_group"
      title="{{ 'officeGroup' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="street_address"
      title="{{ 'streetAddress' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="city"
      title="{{ 'city' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="zip"
      title="{{ 'zipCode' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="state"
      title="{{ 'state' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="phone"
      title="{{ 'phone' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="country"
      title="{{ 'country' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
  </app-data-grid>
